<template>
  <div>
    <b-row>
      <h2>
        {{ $t("checklist.form.edit") + " " + $t("sidebar.brandVehicle") }}
      </h2>
    </b-row>

    <success-fade-alert ref="alertSuccess" :msg="alert.success" />
    <fade-alert-danger ref="alertDanger" :msg="alert.error" />

    <b-row>
      <b-button @click="voltar()" size="sm">
        {{ $t("geral.back") }}
      </b-button>
    </b-row>

    <div style="margin-top: 10px">
      <b-row>
        <b-col lg="6" md="6" sm="6">
          <BrandVehicle :model="model" :modelstate="modelstate" />
        </b-col>
      </b-row>
    </div>

    <b-row style="margin-top: 40px">
      <b-button @click="edit" size="sm">
        {{ $t("geral.save") }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    BrandVehicle: () =>
      import("@/components_rms/System/BrandVehicle/BrandVehicle.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      modelstate: {},
      alert: {
        error: "",
        success: "Registro Editado com sucesso",
      },
      idBrandVehicle: this.$route.params.id,
      model: {
        name: null,
      },
    };
  },
  mounted() {
    this.getBrandVehicle();
  },
  methods: {
    edit() {
      this.modelstate = {};
      let obj = {
        name: this.model.name,
      };
      this.$apiScheduler
        .put(`/brand/edit/${this.idBrandVehicle}`, obj)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.alertDanger.show();
          } else {
            this.$refs.alertSuccess.show();
          }
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    getBrandVehicle() {
      this.$apiScheduler
        .get(`/brand/get/${this.idBrandVehicle}`)
        .then((response) => {
          this.model.name = response.data.name;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    voltar() {
      this.$router.go(-1);
    },
  },
};
</script>